import { render, staticRenderFns } from "./home-menu-open.vue?vue&type=template&id=5f058946&scoped=true"
import script from "./home-menu-open.vue?vue&type=script&lang=js"
export * from "./home-menu-open.vue?vue&type=script&lang=js"
import style0 from "./home-menu-open.vue?vue&type=style&index=0&id=5f058946&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f058946",
  null
  
)

export default component.exports